import { cloneElement, isValidElement, type ReactElement, type ReactNode } from "react"
import classNames from "clsx"

type TooltipProps = {
  label: string
  children: ReactNode
}

export function Tooltip({ label, children }: TooltipProps) {
  if (!isValidElement(children)) {
    return <>{children}</>
  }

  const child = children as ReactElement<{ className?: string }>
  return cloneElement(child, {
    className: classNames(child.props.className, "has-tooltip"),
    ...({ "data-tooltip": label, "aria-description": label } as Record<string, string>),
  })
}

export default Tooltip
